import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import {
    getAllDeploymentGroups,
    createDeploymentGroup,
    getDeploymentGroupUserInfo,
    getDeploymentGroupInfo,
    updateDeploymentGroup
} from 'api/deployment-groups';
import { store } from 'store';

export const initialState = {
    list: [],
    total: 0,
    error: [],
    isLoading: false,
    rowsPerPage: 10,
    currentPage: 1,
    searchQuery: '',
    selected: {},
    newGroup: {}
};

const slice = createSlice({
    name: 'deploymentGroups',
    initialState,
    reducers: {
        setList(state, action) {
            state.list = action.payload.data;
            state.total = action.payload.total;
            state.isLoading = false;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setCurrentPage(state, action) {
            state.currentPage = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        setSearchQuery(state, action) {
            state.currentPage = 1; // reset to page 1
            state.searchQuery = action.payload;
        },
        selectedDeploymentGroup(state, action) {
            state.selected = action.payload;
        },
        setNewGroup(state, action) {
            state.newGroup = action.payload;
        },
        resetDeploymentGroupState() {
            return initialState;
        }
    }
});

export default slice.reducer;

export function searchGroup(query) {
    return async () => {
        dispatch(slice.actions.setSearchQuery(query));
        await getListDeploymentGroups();
    };
}

export function setNewDeploymentGroup(data) {
    return async () => {
        dispatch(slice.actions.setNewGroup(data));
    };
}

export function fetchDeploymentGroupsList() {
    return async () => {
        await getListDeploymentGroups();
    };
}
export function groupCurrentPage(val) {
    return async () => {
        await dispatch(slice.actions.setCurrentPage(val));
        await getListDeploymentGroups();
    };
}

export function groupRowsPerPage(val) {
    return async () => {
        dispatch(slice.actions.setRowsPerPage(val));
    };
}

export function setSelectedGroup(val) {
    return async () => {
        let res = {};
        if (val?._id) res = await getDeploymentGroupInfo({ id: val._id });
        await dispatch(slice.actions.selectedDeploymentGroup(res?.data || {}));
    };
}

export function createNewDeploymentGroup(data) {
    return async () => {
        try {
            const response = await createDeploymentGroup(data);
            await getListDeploymentGroups();
            dispatch(slice.actions.setNewGroup({}));
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    };
}

export function updateDeploymentGroupInfo(data) {
    return async () => {
        try {
            const response = await updateDeploymentGroup(data);
            await getListDeploymentGroups();
            dispatch(slice.actions.setNewGroup({}));
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    };
}

export function getGroupUserInfo(data) {
    return async () => {
        try {
            const response = await getDeploymentGroupUserInfo(data);
            return response;
        } catch (e) {
            throw new Error(e.message);
        }
    };
}

export function initialLoadRequestData() {
    return async () => {
        await dispatch(slice.actions.resetDeploymentGroupState());
        await getListDeploymentGroups();
    };
}

async function getListDeploymentGroups() {
    try {
        dispatch(slice.actions.setIsLoading(true));
        const storeData = store.getState();
        const { currentPage, rowsPerPage, searchQuery } = storeData.deploymentGroups;

        const response = await getAllDeploymentGroups({
            perPage: rowsPerPage,
            pageNo: currentPage,
            query: searchQuery
        });
        dispatch(slice.actions.setList(response?.data));
    } catch (err) {
        console.log(err);
        dispatch(slice.actions.setIsLoading(false));
        throw new Error(err.message);
    }
}
